var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"r-text-body-small"},[_c('span',[_vm._v("אם יש לך שאלה, אנחנו כאן ")]),_c('link-button',{attrs:{"text":"saving@riseup.co.il"},on:{"click":function($event){return _vm.sendMailTo('saving@riseup.co.il')}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }